/* eslint-disable no-undef */
export default class ServicesSlider {

  constructor(args) {
    this.node = args.node;
    this.current = 0;
    this.transition_flag = false;
    this.detached = true;
    this.slides = this.node.querySelectorAll('.services__slide');

    this.init_slides();

    let arrow_button = this.node.querySelector('.services__arrow');

    arrow_button.addEventListener('click', function() {
      if(this.current + 1 <  this.slides.length && this.transition_flag == false && this.detached == false) {
        this.activate(this.current + 1);
      }
    }.bind(this));


    let dots = this.node.querySelectorAll('.services__dot');
    dots.forEach(function(dot){
      dot.addEventListener('click', function() {
        let to_activate_index = dot.dataset.dotIndex;

        if(this.current != to_activate_index && this.transition_flag == false && this.detached == false) {
          this.activate(to_activate_index);
        }
      }.bind(this));
    }.bind(this));


    window.addEventListener('scroll', function() {

      if(this.node.getBoundingClientRect().y < 2) {
        this.attach();
        this.startObserver();
      }
    }.bind(this));
  }

  init_slides() {
    //skip first slide
    for(let i=1; i < this.slides.length; i++) {

      gsap.set(this.slides[i], {
        yPercent: 100,
      });
    }
  }

  attach() {
    this.node.classList.add('services--attach');
    document.querySelector('body').classList.add('container-scroll--lock');
    //document.querySelector('.section__services').classList.add('section__services--current');

    this.detached = false;

  }

  detach() {
    document.querySelector('body').classList.remove('container-scroll--lock');
    this.node.classList.remove('services--attach');
   
    this.detached = true;

  }

  activate(slide_index) {
    slide_index = parseInt(slide_index);
    
    this.transition_flag = true;
    this.slides[this.current].classList.remove('services__slide--current');
    this.slides[slide_index].classList.add('services__slide--current');
    
    let slider = this;
    if(slide_index > this.current) {
      const transition_promise = new Promise((resolve, reject) => {
        slider.set_current_dot(slide_index);
        slider.set_slide_count(this.current, slide_index);
        this.transition_next(slide_index, resolve);
      })
      transition_promise.then(function(){
        slider.transition_flag = false;
        slider.current = slide_index;
      });
    } else {
      const transition_promise = new Promise((resolve, reject) => {
        slider.set_current_dot(slide_index);
        slider.set_slide_count(this.current, slide_index);
        this.transition_prev(slide_index, resolve);
      })
      transition_promise.then(function(){
        slider.transition_flag = false;
        slider.current = slide_index;
      });
    }
  }

  set_current_dot(next_index) {
    let dots = this.node.querySelectorAll('.services__dot');

    dots.forEach(function(elem){
      elem.classList.remove('services__dot--current');
    })
    dots[next_index].classList.add('services__dot--current');
  }

  set_slide_count(previous, next) {
    console.log(previous);
    console.log(next);

    let current = this.node.querySelector('.services__counter-current');

    previous = previous + 1;
    current.classList.remove('services__counter-current--'+previous);
    let num = next + 1;

    current.classList.add('services__counter-current--'+num);

    num = String(num).padStart(2, '0');

    current.innerHTML = num;
  }

  transition_next(to_slide_index, resolve) {
    let transition_up = gsap.timeline({});

    transition_up.fromTo( this.slides[this.current],
    {
      yPercent: 0,
    },
    {
      yPercent: -100,
      duration: 0.3,
    });

    transition_up.fromTo( this.slides[to_slide_index],
    {
      yPercent: 100,
    },
    {
      yPercent: 0,
      duration: 0.3,
    }, '<');

    let slide = this.slides[to_slide_index];
    let text_wrap = slide.querySelector('.services__text-wrap');
    let logo = slide.querySelector('.services__logo');

    let x = slide.classList.contains('services__slide--reverse') ? 50 : -50; 

    transition_up.fromTo(text_wrap,
    {
      opacity: 0,
      x: x,
    },
    {
      x: 0,
      opacity: 1,
      duration: 0.3,
    });

    transition_up.fromTo(logo,
    {
      opacity: 0,
      y: 50,
    },
    {
      y: 0,
      opacity: 1,
      duration: 0.3,
      onComplete: function(){
        resolve();
      },
    });
  }

  transition_prev(to_slide_index, resolve) {
    let transition_down = gsap.timeline({});

    transition_down.fromTo( this.slides[this.current],
    {
      yPercent: 0,
    },
    {
      yPercent: 100,
      duration: 0.3,
    });

    transition_down.fromTo( this.slides[to_slide_index],
    {
      yPercent: -100,
    },
    {
      yPercent: 0,
      duration: 0.3,
    }, '<')

    let slide = this.slides[to_slide_index];
    let text_wrap = slide.querySelector('.services__text-wrap');
    let logo = slide.querySelector('.services__logo');

    let x = slide.classList.contains('services__slide--reverse') ? 50 : -50; 

    transition_down.fromTo(text_wrap,
    {
      opacity: 0,
      x: x,
    },
    {
      x: 0,
      opacity: 1,
      duration: 0.3,
    });

    transition_down.fromTo(logo,
    {
      opacity: 0,
      y: 50,
    },
    {
      y: 0,
      opacity: 1,
      duration: 0.3,
      onComplete: function(){
        resolve();
      },
    });
  }

  startObserver() {
    this.observer = Observer.create({
      target: window,         // can be any element (selector text is fine)
      type: 'wheel,touch',    // comma-delimited list of what to listen for ("wheel,touch,scroll,pointer")
      onUp: function(obs) {
        if(obs.deltaY < -10 && this.current + 1 <  this.slides.length && this.transition_flag == false && this.detached == false) {
          this.activate(this.current + 1);
        }
      }.bind(this), 
      onDown: function(obs) {
        if(this.current == 0 && this.transition_flag == false && this.detached == false) {
          this.detach();
        } else {
          if(obs.deltaY > 10 && this.current - 1 >= 0 && this.transition_flag == false && this.detached == false) {
            this.activate(this.current - 1);
          }
        }
        
      }.bind(this),
      wheelSpeed: -1,
      scrollSpeed: -1,
    });
  }  
}


// WEBPACK FOOTER //
// ./scripts/services_slider.js